"use client"
import { IMG_URL } from '@/app/config'
import { formatDateMonthday, formatDateShort, get } from '@/app/helpers'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import { useTheme } from '@/app/theme-provider';
import Pegination from './Pegination'
import Loader from './Loader';
import useFetch from '@/app/useFetch'


const ExamDetails = () => {
    const { language } = useTheme();
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1); // reset to page 1 when searching
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: list = [], totalPages, loading, error } = useFetch(
        "/website/downloads-examdetails",
        {
            page: currentPage,
            limit: limit,
            search: debouncedSearch,
        },
        [debouncedSearch, currentPage, limit]
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <section className='mt-4'>
            <div className="row mb-3 justify-content-end">
                <div className="search-box d-flex align-items-center">
                    <input
                        type="text"
                        placeholder={language === "en" ? "Search" : "തിരയുക..."}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>
            {loading ? (
                <>
                    <Loader n={24} f={0.3} />

                </>
            ) : <>
                <div className="table-responsive tenders-table">
                    <table className="table  table-bordered text-center align-middle ">
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col">Sl No.</th>
                                <th scope="col">Date</th>
                                <th scope="col">Subject</th>
                                <th scope="col">View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list?.length > 0 ? (
                                <>
                                    {list?.map((item, index) => (
                                        <>
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{formatDateShort(item.date)}</td>
                                                <td>{item.name}</td>
                                                <td>
                                                    <Link target='blank' href={`${IMG_URL}${item.downloadfile}`}>
                                                        <button>View</button>

                                                    </Link>
                                                </td>
                                            </tr>
                                        </>
                                    ))}
                                </>
                            ) : <>
                                <tr>
                                    <td colSpan={4}>
                                        No data found
                                    </td>
                                </tr>

                            </>}




                        </tbody>
                    </table>
                </div>
                {totalPages > 1 && (
                    <Pegination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}

            </>}

        </section>
    )
}

export default ExamDetails
